/*@ngInject*/
const ReportActionUtil = function ($rootScope, $state, $uibModal, coreConstant,
                                   submissionConstant, reportActionsMediator, coreMediator, modalUtil, uiPerformanceLoggerConstant,
                                   currentSubmissionModel, agentQuoteStatus, loadingBarHandler) {


    this.createReport = function (submissionId, reportName) {
        let promise;
        loadingBarHandler.showLoadingBar('submission.report.createReport');
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);

        promise = reportActionsMediator.createReport(submissionId, reportName).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.generateReport = function (reportId) {
        let promise;
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        loadingBarHandler.showLoadingBar('submission.report.generateReport');
        promise = reportActionsMediator.generateReport(reportId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
            loadingBarHandler.hideLoadingBar();
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.editReport = function (reportId) {
        let promise;
        $rootScope.$broadcast(submissionConstant.event.SELECT_DEFAULT_NAVIGATION_ITEM);
        promise = reportActionsMediator.editReport(reportId).then(function () {
            $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
    };

    this.deleteReport = function (submissionId, reportId) {
        modalUtil.showConfirmationModal(submissionId, null, null/*notificationName*/, 'submission.wizard.deleteReport',
            null/*performanceLoggerName*/, /*hideLoadingBar*/false, handleClose);

        function handleClose() {
            let promise = reportActionsMediator.deleteReport(reportId).then(function () {
                $rootScope.$broadcast(submissionConstant.event.REFRESH_BREADCRUMBS);
                $rootScope.$broadcast(submissionConstant.event.REDIRECT_TO_OVERVIEW);
                loadingBarHandler.hideLoadingBar();
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        }
    };

};

angular.module('gw-um-submission').service('reportActionUtil', ReportActionUtil);
